var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login" },
    [
      _c("div", { staticClass: "svg-background" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "100%",
              height: "100%",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c(
              "defs",
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "bgGradient",
                      x1: "0%",
                      y1: "0%",
                      x2: "100%",
                      y2: "100%",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#e6f0ff",
                        "stop-opacity": "1",
                      },
                      attrs: { offset: "0%" },
                    }),
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#f0f7ff",
                        "stop-opacity": "1",
                      },
                      attrs: { offset: "100%" },
                    }),
                  ],
                  1
                ),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "accentGradient1",
                      x1: "0%",
                      y1: "0%",
                      x2: "100%",
                      y2: "100%",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#1890ff",
                        "stop-opacity": "0.3",
                      },
                      attrs: { offset: "0%" },
                    }),
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#722ed1",
                        "stop-opacity": "0.2",
                      },
                      attrs: { offset: "100%" },
                    }),
                  ],
                  1
                ),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "accentGradient2",
                      x1: "100%",
                      y1: "0%",
                      x2: "0%",
                      y2: "100%",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#52c41a",
                        "stop-opacity": "0.25",
                      },
                      attrs: { offset: "0%" },
                    }),
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#faad14",
                        "stop-opacity": "0.2",
                      },
                      attrs: { offset: "100%" },
                    }),
                  ],
                  1
                ),
                _c(
                  "radialGradient",
                  {
                    attrs: {
                      id: "lensGradient",
                      cx: "50%",
                      cy: "50%",
                      r: "50%",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#1890ff",
                        "stop-opacity": "0.15",
                      },
                      attrs: { offset: "0%" },
                    }),
                    _c("stop", {
                      staticStyle: {
                        "stop-color": "#1890ff",
                        "stop-opacity": "0",
                      },
                      attrs: { offset: "100%" },
                    }),
                  ],
                  1
                ),
                _c(
                  "pattern",
                  {
                    attrs: {
                      id: "gridPattern",
                      width: "60",
                      height: "60",
                      patternUnits: "userSpaceOnUse",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M 60 0 L 0 0 0 60",
                        fill: "none",
                        stroke: "rgba(24, 144, 255, 0.08)",
                        "stroke-width": "1.5",
                      },
                    }),
                  ]
                ),
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "glow",
                      x: "-50%",
                      y: "-50%",
                      width: "200%",
                      height: "200%",
                    },
                  },
                  [
                    _c("feGaussianBlur", {
                      attrs: {
                        in: "SourceGraphic",
                        stdDeviation: "5",
                        result: "blur",
                      },
                    }),
                    _c(
                      "feMerge",
                      [
                        _c("feMergeNode", { attrs: { in: "blur" } }),
                        _c("feMergeNode", { attrs: { in: "SourceGraphic" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("rect", {
              attrs: {
                width: "100%",
                height: "100%",
                fill: "url(#bgGradient)",
              },
            }),
            _c("rect", {
              attrs: {
                width: "100%",
                height: "100%",
                fill: "url(#gridPattern)",
              },
            }),
            _c("rect", {
              attrs: {
                x: "10%",
                y: "15%",
                width: "120",
                height: "120",
                rx: "20",
                fill: "url(#accentGradient1)",
                transform: "rotate(15 20% 20%)",
                opacity: "0.6",
              },
            }),
            _c("circle", {
              attrs: {
                cx: "85%",
                cy: "20%",
                r: "80",
                fill: "url(#accentGradient2)",
                opacity: "0.5",
              },
            }),
            _c(
              "g",
              {
                attrs: {
                  fill: "none",
                  stroke: "rgba(24, 144, 255, 0.3)",
                  "stroke-width": "2",
                  filter: "url(#glow)",
                },
              },
              [
                _c("circle", { attrs: { cx: "20%", cy: "30%", r: "45" } }),
                _c("circle", { attrs: { cx: "20%", cy: "30%", r: "35" } }),
                _c("circle", { attrs: { cx: "20%", cy: "30%", r: "25" } }),
                _c("ellipse", {
                  attrs: { cx: "75%", cy: "65%", rx: "55", ry: "35" },
                }),
                _c("ellipse", {
                  attrs: { cx: "75%", cy: "65%", rx: "40", ry: "25" },
                }),
              ]
            ),
            _c(
              "g",
              {
                attrs: {
                  fill: "rgba(24, 144, 255, 0.2)",
                  filter: "url(#glow)",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M 35% 75% l 0 20 l 15 0 l 0 -5 l -10 0 l 0 -5 l 10 0 l 0 -5 l -10 0 l 0 -5 l 15 0 Z",
                    transform: "scale(0.8)",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M 60% 25% l 0 12 l 9 0 l 0 -3 l -6 0 l 0 -3 l 6 0 l 0 -3 l -6 0 l 0 -3 l 9 0 Z",
                    transform: "scale(0.5)",
                  },
                }),
              ]
            ),
            _c(
              "g",
              {
                attrs: {
                  stroke: "rgba(82, 196, 26, 0.4)",
                  "stroke-width": "3",
                  fill: "none",
                  filter: "url(#glow)",
                },
              },
              [
                _c("circle", { attrs: { cx: "30%", cy: "60%", r: "25" } }),
                _c("circle", { attrs: { cx: "45%", cy: "60%", r: "25" } }),
                _c("path", {
                  attrs: { d: "M 32% 60% L 43% 60%", "stroke-width": "2" },
                }),
                _c("path", {
                  attrs: {
                    d: "M 20% 60% L 10% 55% L 8% 70%",
                    "stroke-width": "2",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M 55% 60% L 65% 55% L 67% 70%",
                    "stroke-width": "2",
                  },
                }),
              ]
            ),
            _c("circle", {
              attrs: {
                cx: "15%",
                cy: "30%",
                r: "50",
                fill: "url(#lensGradient)",
                filter: "url(#glow)",
              },
            }),
            _c("circle", {
              attrs: {
                cx: "90%",
                cy: "80%",
                r: "40",
                fill: "url(#lensGradient)",
                filter: "url(#glow)",
              },
            }),
            _c(
              "g",
              {
                attrs: {
                  stroke: "rgba(24, 144, 255, 0.2)",
                  "stroke-width": "1.5",
                  "stroke-dasharray": "5,5",
                },
              },
              [
                _c("line", {
                  attrs: { x1: "20%", y1: "25%", x2: "45%", y2: "40%" },
                }),
                _c("line", {
                  attrs: { x1: "75%", y1: "35%", x2: "60%", y2: "55%" },
                }),
                _c("line", {
                  attrs: { x1: "30%", y1: "65%", x2: "50%", y2: "75%" },
                }),
                _c("line", {
                  attrs: { x1: "65%", y1: "70%", x2: "80%", y2: "85%" },
                }),
              ]
            ),
            _c(
              "g",
              {
                attrs: {
                  fill: "rgba(24, 144, 255, 0.6)",
                  filter: "url(#glow)",
                },
              },
              [
                _c("circle", { attrs: { cx: "12%", cy: "18%", r: "3" } }),
                _c("circle", { attrs: { cx: "95%", cy: "25%", r: "3" } }),
                _c("circle", { attrs: { cx: "8%", cy: "85%", r: "3" } }),
                _c("circle", { attrs: { cx: "88%", cy: "92%", r: "3" } }),
                _c("circle", { attrs: { cx: "45%", cy: "15%", r: "2.5" } }),
                _c("circle", { attrs: { cx: "55%", cy: "95%", r: "2.5" } }),
                _c("circle", { attrs: { cx: "35%", cy: "45%", r: "2" } }),
                _c("circle", { attrs: { cx: "65%", cy: "65%", r: "2" } }),
              ]
            ),
            _c(
              "circle",
              {
                attrs: {
                  cx: "5%",
                  cy: "50%",
                  r: "4",
                  fill: "#1890ff",
                  opacity: "0.7",
                  filter: "url(#glow)",
                },
              },
              [
                _c("animate", {
                  attrs: {
                    attributeName: "cx",
                    from: "5%",
                    to: "95%",
                    dur: "8s",
                    repeatCount: "indefinite",
                  },
                }),
              ]
            ),
            _c(
              "circle",
              {
                attrs: {
                  cx: "95%",
                  cy: "30%",
                  r: "3",
                  fill: "#52c41a",
                  opacity: "0.6",
                  filter: "url(#glow)",
                },
              },
              [
                _c("animate", {
                  attrs: {
                    attributeName: "cy",
                    from: "30%",
                    to: "80%",
                    dur: "6s",
                    repeatCount: "indefinite",
                  },
                }),
              ]
            ),
            _c(
              "text",
              {
                attrs: {
                  x: "50%",
                  y: "12%",
                  "text-anchor": "middle",
                  "font-family": "Arial, sans-serif",
                  "font-size": "24",
                  fill: "rgba(24, 144, 255, 0.1)",
                  "font-weight": "bold",
                },
              },
              [_vm._v(" LONGDA OPTICS ")]
            ),
          ]
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            "label-position": "left",
            "label-width": "0px",
          },
        },
        [
          _c("div", { staticClass: "title-section" }, [
            _c("h3", { staticClass: "title" }, [_vm._v("龙达光学管理系统")]),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v("Management System"),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "username" } },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    type: "text",
                    "auto-complete": "off",
                    placeholder: "账号",
                  },
                  model: {
                    value: _vm.loginForm.username,
                    callback: function ($$v) {
                      _vm.$set(_vm.loginForm, "username", $$v)
                    },
                    expression: "loginForm.username",
                  },
                },
                [
                  _c("svg-icon", {
                    staticClass: "el-input__icon",
                    staticStyle: {
                      height: "39px",
                      width: "13px",
                      "margin-left": "2px",
                      "line-height": "39px",
                      "margin-top": "8px",
                    },
                    attrs: { slot: "prefix", "icon-class": "user" },
                    slot: "prefix",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "password" } },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    type: "password",
                    "auto-complete": "off",
                    placeholder: "密码",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleLogin($event)
                    },
                  },
                  model: {
                    value: _vm.loginForm.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.loginForm, "password", $$v)
                    },
                    expression: "loginForm.password",
                  },
                },
                [
                  _c("svg-icon", {
                    staticClass: "el-input__icon",
                    staticStyle: {
                      height: "39px",
                      width: "13px",
                      "margin-left": "2px",
                      "margin-top": "8px",
                    },
                    attrs: { slot: "prefix", "icon-class": "password" },
                    slot: "prefix",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "code" } },
            [
              _c("el-input", {
                staticStyle: { width: "60%" },
                attrs: { "auto-complete": "off", placeholder: "验证码" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleLogin($event)
                  },
                },
                model: {
                  value: _vm.loginForm.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "code", $$v)
                  },
                  expression: "loginForm.code",
                },
              }),
              _c("div", { staticClass: "login-code" }, [
                _c("img", {
                  attrs: { src: _vm.codeUrl },
                  on: { click: _vm.getCode },
                }),
              ]),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "100%", "line-height": "56px" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    loading: _vm.loading,
                    size: "medium",
                    type: "primary",
                  },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleLogin($event)
                    },
                  },
                },
                [
                  !_vm.loading
                    ? _c("span", [_vm._v("登 录")])
                    : _c("span", [_vm._v("登 录 中...")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }